import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium leading-none transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-warm-800 text-white',
        secondary: 'bg-warm-100 text-text-secondary',
        outline: 'border border-border text-text-secondary',
        destructive: 'bg-danger-bg text-danger-fg',
        success: 'bg-success-bg text-success-fg',
        warning: 'bg-warning-bg text-warning-fg',
        info: 'bg-info-bg text-info-fg',
        core: 'bg-[#ede9f5] text-[#5b4a80]',
        market: 'bg-market-50 text-market-700',
        business: 'bg-business-50 text-business-800',
        solution: 'bg-solution-50 text-solution-700',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
